<!--
 * @Author: 戴东宇
 * @Date: 2021-12-20 14:44:59
 * @LastEditTime: 2022-08-09 16:33:24
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/Register/index.vue
-->
<template>
  <div class="app">
    <div class="registerBox">
      <p class="shopName">{{ shopInfo.name }}</p>
      <p class="welcome_join">欢迎您成为尊贵的会员</p>
      <div class="rightBox">
        <!-- <div class="Tips" style="margin-bottom:4px;">必填信息</div> -->
        <div class="Requirement">
          <input
            class="rigRe"
            type="text"
            placeholder="请输入姓名"
            v-model="name"
            @focus="focus"
            @blur="blur"
          />
        </div>
        <div class="Requirement margintops">
          <input
            class="rigRe fr"
            type="number"
            placeholder="请输入手机号"
            pattern="[0-9]*"
            v-model="tel"
            @focus="focus"
            @blur="blur"
          />
        </div>
        <div class="Requirement margintops flexbox">
          <input
            class="rigRe"
            type="number"
            style="width:57%"
            placeholder="请输入验证码"
            pattern="[0-9]*"
            v-model="vcode"
            @focus="focus"
            @blur="blur"
          />
          <div
            class="vcodeSty"
            @click="clickVcode"
            :class="itemFlase ? '' : 'vcodeStyFa'"
          >
            {{ itemFlase ? "获取验证码" : idx }}
          </div>
        </div>

        <div
          class="Determine"
          :class="disabled === true ? 'dis' : ''"
          @click="disabled === true ? '' : clickApply()"
        >
          注册
        </div>
        <p class="vip_bind" @click="handleToBind">已有账号，去绑卡</p>
        <p class="vip_tit">----{{ shopInfo.content.title || "" }}----</p>
        <!-- <p class="vip_save">充值100赠50</p> -->
        <p
          class="vip_detail"
          v-for="(item, idx) in shopInfo.content.content"
          :key="idx"
        >
          (2022-2-12至2022-5-20)
        </p>
      </div>
    </div>
    <!-- <Promptbox v-if="prom" :message="Tips"></Promptbox> -->
    <loading v-if="load"></loading>
    <div class="toast" v-show="toast">{{ toastText }}</div>
  </div>
</template>
<script>
export default {
  name: "Register",
  data() {
    return {
      name: "",
      tel: "",
      vcode: "",
      idx: 60,
      itemFlase: true,
      toast: false,
      toastText: "",
      load: false,
      disabled: false,
      shopInfo: {}
    };
  },
  mounted() {
    const shopInfo = JSON.parse(this.$route.query.shopInfo);
    console.log(shopInfo);
    this.shopInfo = shopInfo;
  },
  methods: {
    handleToBind() {
      window.location.href = `/#/BindingMember`;
    },
    focus() {},
    blur() {},
    clickVcode() {
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!!reg_tel.test(this.tel)) {
        if (this.itemFlase) {
          this.load = true;
          this.itemFlase = false;
          this.RequestVIP(`/h5/vip/sms?tel=${this.tel}`, r => {
            console.log(r);
            if (r.data.code === "20000") {
              this.load = false;
              this.toast = true;
              this.toastText = "验证码已发送";
              setTimeout(() => {
                this.toast = false;
              }, 1000);
              this.idx = 60;
              let timer = setInterval(() => {
                this.idx -= 1;
                if (this.idx == 0) {
                  this.itemFlase = true;
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.toast = true;
              this.toastText = r.data.msg;
              this.load = false;
              setTimeout(() => {
                this.toast = false;
              }, 1000);
            }
          });
        }
      } else {
        this.toast = true;
        this.toastText = "请填写正确的手机号";
        setTimeout(() => {
          this.toast = false;
        }, 1000);
      }
    },
    clickApply() {
      console.log(this.name, this.tel, this.vcode);
      const companyID = localStorage.getItem("companyID");
      if (!this.name || !this.tel || !this.vcode) {
        this.toast = true;
        this.toastText = "请先填写完整信息";
        setTimeout(() => {
          this.toast = false;
        }, 1000);
        return;
      }
      this.disabled = true;
      this.RequestVIP(
        `/h5/vip/sms/check?tel=${this.tel}&code=${this.vcode}`,
        r => {
          console.log(r, "rrrr");
          if (r.data.code === "20000") {
            const code = localStorage.getItem("code");
            this.RequestVIP3(
              `/h5/vip/info/${code}`,
              { username: this.name, tel: this.tel },
              res => {
                this.disabled = false;
                if (res.data.code === "20000") {
                  this.toast = true;
                  this.toastText = "注册成功！";
                  setTimeout(() => {
                    const baseUrl = window.location.origin;
                    this.toast = false;
                    window.location.href = `${baseUrl}/vip-h5/api/v2/h5/vip?companyID=${companyID}`;
                  }, 1000);
                } else {
                  this.toast = true;
                  this.toastText = res.data.msg;
                  setTimeout(() => {
                    this.toast = false;
                  }, 1000);
                }
                console.log(res, "resullllllllllllllll");
              }
            );
          } else {
            this.toast = true;
            this.toastText = res.data.msg;
            setTimeout(() => {
              this.toast = false;
            }, 1000);
          }
        },
        err => {
          this.toast = false;
        }
      );
    }
  }
};
</script>
<style scoped>
.app {
  height: 100%;
  width: 100%;
  background: #f5f5f5;
}
.vip_bind {
  width: 100%;
  text-align: right;
  font-size: 8px;
  color: #757575;
  margin-top: 8px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.registerBox {
  width: calc(100% - 28px);
  margin-left: 14px;
  background: #f5f5f5;
  border-radius: 5px;
  height: 74%;
  padding-top: 25px;
  /* box-shadow: 0px 0px 5px 0px #bdbdbd; */
  position: relative;
}
.rightBox {
  width: 100%;
  height: 100%;
  margin-top: 10px;
}
.Tips {
  font-size: 12px;
  color: #757575;
  height: 20px;
  line-height: 20px;
}
.Requirement {
  height: 29px;
  line-height: 29px;
  font-size: 11px;
  color: #212121;
  position: relative;
}
.letRe {
  width: 22%;
  height: 100%;
}
.rigRe {
  display: block;
  height: 29px;
  width: 100%;
  padding: 9px 14px;
  box-sizing: border-box;
  border: none;
  border: 1px solid #e0e0e0;
  opacity: 1;
  border-radius: 3px;
  font-size: 11px;
}
input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}
input {
  outline: none;
}
.Tips {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  border: none !important;
  font-size: 8px;
}
.Tips_lo {
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #46a1ff;
  margin-top: 4px;
  margin-right: 3%;
  font-size: 8px;
}
.Tips_text {
  color: #757575;
  line-height: 20px;
}
.Determine {
  width: 100%;
  height: 29px;
  text-align: center;
  line-height: 29px;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  opacity: 1;
  border-radius: 3px;
  font-size: 13px;
  color: #212121;
  box-sizing: border-box;
  margin-top: 37px;
}
.vcodeSty {
  width: 72px;
  height: 29px;
  line-height: 29px;
  text-align: center;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #bdbdbd;
  font-size: 11px;
  font-weight: 400;
  color: #757575;
  border-radius: 1px;
  box-sizing: border-box;
}
.vcodeStyFa {
  border: 0.5px solid #bdbdbd;
  color: #bdbdbd;
}
.toast {
  width: 100px;
  /* height: 30px; */
  line-height: 15px;
  padding: 10px;
  border-radius: 5px;
  background: rgb(49, 47, 47);
  opacity: 0.5;
  color: white;
  position: fixed;
  top: 46%;
  left: 30%;
  text-align: center;
  font-size: 10px;
}
.dis {
  background: gray;
}
.returns {
  position: fixed;
  top: 80%;
  left: 0;
}
.gantan {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  color: #fff;
  font-size: 8px;
  text-align: center;
  line-height: 10px;
}
.shopName {
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
  color: #212121;
}
.welcome_join {
  font-size: 11px;
  margin-top: 10px;
  font-weight: 400;
  line-height: 19px;
  color: #212121;
}
.margintops {
  margin-top: 11px;
}
.flexbox {
  display: flex;
  justify-content: space-between;
}
.vip_tit {
  width: 100%;
  text-align: center;
  font-size: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  font-weight: 400;
  line-height: 17px;
  color: #212121;
  opacity: 1;
}
.vip_save,
.vip_detail {
  text-align: center;
  font-size: 10px;
  margin-top: 2px;
  font-weight: 400;
  line-height: 17px;
  color: #212121;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/RegisterByCode/index.vue